import { render, staticRenderFns } from "./CardWidgetCard.vue?vue&type=template&id=75619118"
import script from "./CardWidgetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardWidgetCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardWidgetCard.vue?vue&type=style&index=0&id=75619118&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports